import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import UserAvatar from 'components/UserAvatar';
// utils
import classnames from 'classnames/bind';
import { getUserNickname } from 'utils';
// styles
import styles from './MobileRow.module.scss';

const cn = classnames.bind(styles);

const MobileUserRow = ({ name, user, actionBtnType, disabledRow, onRowClick, selectedRow }) => (
  <div
    className={cn('MobileRow', { 'no-events': disabledRow, 'select-row': actionBtnType === 'button' })}
    onClick={onRowClick}
  >
    <UserAvatar user={user} size={40} />
    <div className={cn('name-column')}>
      <div className={cn('name')}>{name}</div>
      {user &&
        <div className={cn('nickname')}>@{getUserNickname(user)}</div>}
    </div>
    {actionBtnType === 'button' && (
      <Button disabled={selectedRow} className={cn('select-btn')} small primary>
        <FormattedMessage id="general.button.select" />
      </Button>
    )}
    {actionBtnType === 'checkbox' && (
      <div className={cn('icon', { 'selected': selectedRow })}>
        <i className={cn('checked', 'fa fa-check-circle-bts')} />
        <i className={cn('unchecked', 'fa fa-radio-unchecked')} />
      </div>
    )}
  </div>
);

MobileUserRow.propTypes = {
  actionBtnType: T.string.isRequired,
  user: T.object,
  name: T.string,
  disabledRow: T.bool,
  onRowClick: T.func.isRequired,
  selectedRow: T.bool,
};

export default MobileUserRow;
